import { render, staticRenderFns } from "./_SearchableColumns.vue?vue&type=template&id=b8a08934&"
import script from "./_SearchableColumns.vue?vue&type=script&lang=ts&"
export * from "./_SearchableColumns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports